import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { Organization } from '@contrast-security-inc/base-types'
import {
  Tab,
  TabList,
  TabPanel,
  TabProvider
} from '@contrast-security-inc/design-system-navigations'
import { GridType, Library } from '../../../helpers/ui-interfaces'
import { LibraryGridPanelID } from '../../../helpers/drilldown-ui-interfaces'
import { LibraryUsageGrid } from '../../library-usage-grid/grid'
import { OssUnlicensedState } from './library-usage-unlicensed-state'
import { OverviewTab } from './overview-tab'
import { styles } from './styles'

const topMarginCss = css`
  margin-top: 18px;
`

interface Props {
  library: Library
  defaultTabID?: LibraryGridPanelID
  ossEnabled: boolean | undefined
  gridType: GridType
  applicationID?: string
  organizationID: string
  organization: Organization
}

export const DrilldownContentViewTabs = ({
  library,
  defaultTabID = LibraryGridPanelID.Overview,
  ossEnabled = false,
  gridType,
  applicationID,
  organizationID,
  organization
}: Props) => {
  const intl = useIntl()

  const [selectedTab, setSelectedTab] =
    React.useState<LibraryGridPanelID>(defaultTabID)

  const navigateToUsageTab = () => setSelectedTab(LibraryGridPanelID.Usage)

  return (
    <div
      className={css`
        div > span {
          margin-top: -2px;
        }
      `}
    >
      {ossEnabled}
      <TabProvider value={selectedTab}>
        <TabList
          isExtended={gridType === 'Application'}
          className={css`
            /* Hide tabs when there's only one tab to display */
            ${gridType !== 'Application' && '&&& {display: none;}'}
          `}
          onChange={(_, value) => setSelectedTab(value as LibraryGridPanelID)}
        >
          <Tab
            testId="tab-heading-overview"
            label={intl.formatMessage({ id: 'title_overview' })}
            value="overview"
          />
          {gridType === 'Application' ? (
            <Tab
              testId="tab-heading-usage"
              label={intl.formatMessage({ id: 'title_usage' })}
              value="usage"
            />
          ) : null}
        </TabList>
        <TabPanel value="overview">
          <div className={topMarginCss}>
            <OverviewTab
              library={library}
              applicationID={applicationID}
              navigateToUsageTab={navigateToUsageTab}
              organizationID={organizationID}
              organization={organization}
              gridType={gridType}
            />
          </div>
        </TabPanel>
        {gridType === 'Application' ? (
          <TabPanel value="usage">
            <div className={topMarginCss}>
              {ossEnabled ? (
                <div className={styles.LibraryUsageGridPanelContent}>
                  {applicationID && (
                    <LibraryUsageGrid
                      language={library.language}
                      libraryHash={library.hash}
                      library={library}
                      applicationID={applicationID}
                    />
                  )}
                </div>
              ) : (
                <OssUnlicensedState />
              )}
            </div>
          </TabPanel>
        ) : null}
      </TabProvider>
    </div>
  )
}
